export const DEAL_BOND_DOCUMENT_SEGMENT_EVENTS = {
  BondDocumentError: 'Deals Dashboard - View Bond Document error on fetching',
  BondDocumentRequested: 'Deals Dashboard - Bond Document requested',
} as const;
